import {
  observable,
  action
} from 'mobx';
import baseApi from '../../tool/base';
import {
  message
} from 'antd';
import util from '../../util/index';

const searchValue = {
  userName: '',
  auth: '-1',
};
const {
  catchApiError,
  getEcId,
  getAccessToken,
} = util;
export class AuthorityStore {

  constructor(routing) {
    this.routing = routing;
    this.addAuth = this.addAuth.bind(this);
    this.getAuth = this.getAuth.bind(this);
    this.setPage = this.setPage.bind(this);
    this.setSearchValue = this.setSearchValue.bind(this);
    this.resetSearchValue = this.resetSearchValue.bind(this);
  }

  @observable loading = false;
  @observable page = {
    current: 1,
    pageSize: 10,
    total: 0,
  }
  @observable authDatas = [];
  @observable searchValue = searchValue;

  @action


  setPage(params = {}) {
    this.page = {
      ...this.page,
      ...params
    };
  }

  addAuth(params = {}, addOrDelete) {
    let ecId = getEcId();
    baseApi.callApi("/product/price/addAuth/" + params.ecId + '/' + addOrDelete, 'POST', {
      // ...params,
      ecId: params.ecId,
      access_token: getAccessToken(),
    }, 'json', 'json').then((data) => catchApiError(data, this.routing)).then((data, reject) => {
        if (data && data.code === 0) {
          message.error(data.errMsg);
        } else {
          message.success('设置成功！');
          this.getAuth();
        }        
      })
      .catch((err) => {
        console.log(err);
        message.error("系统错误，请联系管理员");
      });
  }

  getAuth(params = {}) {
    let ecId = getEcId();
    this.loading = true;
    let auth = this.searchValue.auth === '-1' ? '' : this.searchValue.auth;
    const param = {
      ...params,
      userName: this.searchValue.userName,
      auth,
      ecId,
      pageNum: this.page.current,
      pageSize: this.page.pageSize,
      access_token: getAccessToken(),
    };
    baseApi.callApi('/product/price/users', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data, reject) => {
      this.loading = false;
      if (data && data.code === 0) {
          message.error(data.errMsg);
        } else if (data && data.code === 402) {
          message.error(data.msg);
        } else {
          this.authDatas = data.data.data;
          this.page.total = data.data.count;
        }
      })
      .catch((err) => {
        // console.log(err);
        // message.error("系统错误，请联系管理员");
      });
  }

  setSearchValue(params = {}) {
    this.searchValue = {
      ...this.searchValue,
      ...params
    };
  }

  resetSearchValue() {
    this.searchValue = searchValue;
    this.getAuth();
  }

}


// WEBPACK FOOTER //
// ./src/stores/setting/AuthorityStore.js